import { HttpResult, loadedAsyncState } from 'widgets-for-react'
import { loadBreadcrumbs } from '../../drupal/api.mod'
import { TransformStandardBlock } from '../../drupal/drupal_to_cms.mod'
import { Locale } from '../../drupal/types_and_parser/extra_types.mod'
import { entity_parser } from '../../drupal/types_and_parser/parser'
import { ParsedEntity, ParsedParagraph } from '../../drupal/types_and_parser/types'
import { getLangFromUrl, removeLangFromUrl } from '../utils/history.mod'
import { Page } from './state'

export const getPage = async (slug: string): Promise<HttpResult<Page>> =>
  getDrupalNode(slug)
    .then<HttpResult<Page>>((page: HttpResult<CustomParsedEntity> & { is_preview: boolean }): HttpResult<Page> => {
      if (page.kind != 'result') return { kind: 'failed', status: 404 }
      if (page.value.entity_type != 'node') return { kind: 'failed', status: 404 }
      return {
        kind: 'result',
        value: {
          blocks: page.value.field_page_content.map((b: ParsedParagraph) => TransformStandardBlock(b)).toArray(),
          breadcrumbs: page.is_preview
            ? loadedAsyncState([])
            : loadBreadcrumbs(page.value.language_links.get(page.value.language), getLangFromUrl()),
          node: { ...page.value, is_preview: page.is_preview }
        },
        status: 200
      }
    })
    .catch((e) => {
      console.error('This error occurred in getPage:', e)
      return e
    })

const getDrupalNode = async (_slug: string): Promise<HttpResult<CustomParsedEntity> & { is_preview: boolean }> => {
  const lang: Locale | null = _slug ? getLangFromUrl() : 'global'
  const localePart = lang == 'global' ? '' : `/${lang}`
  const slug = lang == 'global' ? _slug : removeLangFromUrl(_slug)
  const is_preview = slug && slug?.startsWith('preview')

  const url = [undefined, null, '', '/', lang].includes(slug)
    ? `/api/drupal${localePart}/api/homepage`
    : is_preview
    ? `/api/drupal${localePart}/api/${slug}` + window.location.search
    : `/api/drupal${localePart}/${slug}`

  const res = await fetch(url)

  if (!res.ok) return { kind: 'failed', status: 400, is_preview }

  const json = await res.json()

  if (Array.isArray(json)) {
    if (json.length == 0) return { kind: 'failed', status: 400, is_preview }

    const parsed = entity_parser(json.shift() as any)
    return { kind: 'result', status: 200, value: { ...parsed, locale: lang }, is_preview }
  }

  const parsed = entity_parser(json as any) as CustomParsedEntity
  return { kind: 'result', status: 200, value: { ...parsed, locale: lang }, is_preview }
}

export type CustomParsedEntity = ParsedEntity & {
  locale: Locale | null
}
